class ReportController {
    constructor(apiService) {
        this.apiService = apiService;
    }

    /**
     * Create a report (post, user, company)
     * @param {Object} input - { type: 'post'|'user'|'company'|'market_listing', reason, description?, reportedPostId?, reportedUserId?, reportedCompanyId? }
     */
    async createReport(input) {
        return this.apiService.post('/reports', input).then((res) => res.data);
    }

    /**
     * Get all reports with filters
     * @param {Object} params - { type?, reason?, status?, page?, limit? }
     * @returns {Promise}
     */
    async getReports(params = {}) {
        const queryParams = new URLSearchParams();
        if (params.type) queryParams.append('type', params.type);
        if (params.reason) queryParams.append('reason', params.reason);
        if (params.status) queryParams.append('status', params.status);
        if (params.page) queryParams.append('page', params.page);
        if (params.limit) queryParams.append('limit', params.limit);
        
        const queryString = queryParams.toString();
        const url = `/reports${queryString ? `?${queryString}` : ''}`;
        
        return this.apiService.get(url).then(res => res.data);
    }

    /**
     * Get report statistics
     * @returns {Promise}
     */
    async getReportStats() {
        return this.apiService.get('/reports/stats').then(res => res.data);
    }

    /**
     * Get a specific report by ID
     * @param {string} reportId
     * @returns {Promise}
     */
    async getReportById(reportId) {
        return this.apiService.get(`/reports/${reportId}`).then(res => res.data);
    }

    /**
     * Update a report
     * @param {string} reportId
     * @param {Object} updateData - { status?, adminNotes? }
     * @returns {Promise}
     */
    async updateReport(reportId, updateData) {
        return this.apiService.patch(`/reports/${reportId}`, updateData).then(res => res.data);
    }

    /**
     * Delete a report
     * @param {string} reportId
     * @returns {Promise}
     */
    async deleteReport(reportId) {
        return this.apiService.delete(`/reports/${reportId}`).then(res => res.data);
    }

    /**
     * Resolve a report
     * @param {string} reportId
     * @param {string} adminNotes
     * @returns {Promise}
     */
    async resolveReport(reportId, adminNotes = '') {
        return this.updateReport(reportId, {
            status: 'resolved',
            adminNotes,
        });
    }

    /**
     * Dismiss a report
     * @param {string} reportId
     * @param {string} adminNotes
     * @returns {Promise}
     */
    async dismissReport(reportId, adminNotes = '') {
        return this.updateReport(reportId, {
            status: 'dismissed',
            adminNotes,
        });
    }

    /**
     * Set report to under review
     * @param {string} reportId
     * @param {string} adminNotes
     * @returns {Promise}
     */
    async setUnderReview(reportId, adminNotes = '') {
        return this.updateReport(reportId, {
            status: 'under_review',
            adminNotes,
        });
    }
}

export default ReportController;
